import InteractiveContainer from './interactive-container';

/**
 * The base ItemRenderer component you extend when creating your own visual representation of the Item type.
 *
 * It is what a {@link List} draws a row with: something that can be handed an Item, and handed back when the List is done with it. Nothing here selects — a row that the user picks from a set is a {@link SelectListItemRenderer}, which adds that on top of this.
 */
export default class ListItemRenderer<Item> extends InteractiveContainer {
	/** The item property defines the data item type that the ItemRenderer should present visually. */
	public set item(value: Item | null) {
		if (this.#item === value) {
			return;
		}
		this.#item = value;
		this.#itemChanged = true;
		this.invalidateProperties();
	}

	public get item(): Item | null {
		return this.#item;
	}

	#item: Item | null;
	#itemChanged: boolean;

	public constructor() {
		super();
		this.#item = null;
		this.#itemChanged = false;
	}

	/**
	 * The dispose method will be invoked by the List before the ItemRenderer is removed from the DOM and added to the instance pool.
	 *
	 * Override this method when you want to remove event listeners or Observable subscriber functions.
	 */
	public dispose(): void {
		// override in sub classes
	}

	protected override commitProperties(): void {
		super.commitProperties();
		if (this.#itemChanged) {
			this.#commitItem();
		}
	}

	protected itemChanged(): void {
		// override in sub classes
	}

	#commitItem(): void {
		this.#itemChanged = false;
		this.itemChanged();
	}
}
customElements.define('ac-list-item-renderer', ListItemRenderer);
